import React, { useEffect, useState } from "react";
import "./Govindas.css";
import LazyImage from "../components/LazyImage";

import food1 from "../assets/images/govindas/food1.jpeg";
import food4 from "../assets/images/govindas/food4.jpeg";
import party1 from "../assets/images/govindas/party1.jpeg";
import party2 from "../assets/images/govindas/party2.jpeg";
import interior1 from "../assets/images/govindas/interior1.jpeg";
import interior2 from "../assets/images/govindas/interior2.jpeg";
import interior3 from "../assets/images/govindas/interior3.jpeg";
import interior4 from "../assets/images/govindas/interior4.jpeg";

const imageData = [
  {
    url: interior1,
    category: "Ambience",
    alt: "Govindas restaurant dining area",
  },
  {
    url: interior2,
    category: "Ambience",
    alt: "Restaurant interior and seating",
  },
  {
    url: interior3,
    category: "Ambience",
    alt: "Govindas dining experience",
  },
  {
    url: interior4,
    category: "Ambience",
    alt: "Restaurant seating and decor",
  },
  {
    url: food4,
    category: "Food",
    alt: "Vegetarian dish served at Govindas",
  },
  {
    url: food1,
    category: "Food",
    alt: "Vegetarian food presentation",
  },
  {
    url: party1,
    category: "Party",
    alt: "Celebration setup at Govindas",
  },
  {
    url: party2,
    category: "Party",
    alt: "Special occasion decorations",
  },
];

const categories = ["All", "Food", "Ambience", "Party"];

const highlights = [
  {
    icon: "✦",
    title: "Pure Vegetarian",
    description: "A vegetarian dining experience rooted in devotion.",
  },
  {
    icon: "❋",
    title: "A Peaceful Ambience",
    description: "A welcoming setting for family and friends.",
  },
  {
    icon: "♡",
    title: "Celebrate Together",
    description: "Make birthdays and special occasions memorable.",
  },
];

const Govindas = () => {
  const [filter, setFilter] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  const phoneNumber = "+919669055560";

  const whatsappMessage = encodeURIComponent(
    "Hare Krishna! I would like to enquire about Govindas Restaurant.",
  );

  const filteredImages =
    filter === "All"
      ? imageData
      : imageData.filter((image) => image.category === filter);

  // Scroll to an element without optional chaining.
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Feature-card handler.
  const handleFeatureClick = (category) => {
    setFilter(category);
    scrollToSection("govindas-gallery");
  };

  // Close the image preview with the Escape key.
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedImage(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <main className="govindas-page">
      {/* Hero */}
      <section
        className="govindas-hero"
        style={{ backgroundImage: `url("${interior1}")` }}
      >
        <div className="govindas-hero-overlay" />

        <div className="govindas-hero-content">
          <span className="govindas-eyebrow">A DIVINE DINING EXPERIENCE</span>

          <h1>Welcome to Govindas</h1>

          <p>
            Delicious vegetarian cuisine, a peaceful ambience, and a dining
            experience inspired by devotion to Krishna.
          </p>

          <div className="govindas-hero-actions">
            <button
              type="button"
              className="govindas-btn govindas-btn-gold"
              onClick={() => scrollToSection("govindas-food")}
            >
              Explore Our Gallery{" "}
            </button>

            <button
              type="button"
              className="govindas-btn govindas-btn-outline"
              onClick={() => scrollToSection("govindas-contact")}
            >
              Contact Us
            </button>
          </div>
        </div>

        <div className="govindas-hero-caption">
          <span>ISKCON Ujjain</span>
          <span aria-hidden="true">·</span>
          <span>A place to gather and share</span>
        </div>
      </section>

      {/* Introduction */}
      <section className="govindas-intro section-container">
        <span className="govindas-section-label">OUR RESTAURANT</span>

        <h2>A Taste of Goodness</h2>

        <p>
          Govindas Restaurant brings together vegetarian cuisine, warm
          hospitality, and a welcoming atmosphere. Enjoy a meal with family and
          friends in a setting inspired by the spirit of Krishna consciousness.
        </p>

        <div className="govindas-divider" aria-hidden="true">
          <span />
          <span className="govindas-divider-symbol">✦</span>
          <span />
        </div>

        <div className="govindas-highlights">
          {highlights.map((item) => (
            <article className="govindas-highlight-card" key={item.title}>
              <span className="govindas-highlight-icon" aria-hidden="true">
                {item.icon}
              </span>

              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Featured sections */}
      <section className="govindas-food-section" id="govindas-food">
        <div className="section-container">
          <div className="govindas-section-heading">
            <div>
              <span className="govindas-section-label">MADE TO BE SHARED</span>

              <h2>Discover the Experience</h2>

              <p>
                Explore our food, inviting interiors, and special celebrations.
              </p>
            </div>
          </div>

          <div className="govindas-feature-grid">
            <button
              type="button"
              className="govindas-feature-card govindas-feature-large"
              onClick={() => handleFeatureClick("Food")}
              aria-label="Explore food photos"
            >
              <LazyImage
                src={food1}
                alt="Vegetarian food at Govindas"
                className="govinda-image"
              />

              <span className="govindas-feature-overlay">
                <span>THE FOOD</span>
                <strong>A Feast for the Senses</strong>
                <span className="govindas-feature-link">Explore photos ↗</span>
              </span>
            </button>

            <button
              type="button"
              className="govindas-feature-card"
              onClick={() => handleFeatureClick("Ambience")}
              aria-label="Explore restaurant ambience photos"
            >
              <LazyImage
                src={interior2}
                alt="Warm and inviting restaurant interior"
                className="govinda-image"
              />

              <span className="govindas-feature-overlay">
                <span>THE AMBIENCE</span>
                <strong>Feel at Home</strong>
                <span className="govindas-feature-link">Explore photos ↗</span>
              </span>
            </button>

            <button
              type="button"
              className="govindas-feature-card"
              onClick={() => handleFeatureClick("Party")}
              aria-label="Explore celebration photos"
            >
              <LazyImage
                src={party1}
                alt="Celebration decorations at Govindas"
                className="govinda-image"
              />

              <span className="govindas-feature-overlay">
                <span>SPECIAL MOMENTS</span>
                <strong>Celebrate Together</strong>
                <span className="govindas-feature-link">Explore photos ↗</span>
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="govindas-gallery-section" id="govindas-gallery">
        <div className="section-container">
          <div className="govindas-section-heading">
            <div>
              <span className="govindas-section-label">A CLOSER LOOK</span>

              <h2>Moments at Govindas</h2>

              <p>A glimpse of the food, ambience, and celebrations.</p>
            </div>
          </div>

          <div className="govindas-filters" aria-label="Filter gallery images">
            {categories.map((category) => (
              <button
                type="button"
                key={category}
                className={
                  "govindas-filter-btn" + (filter === category ? " active" : "")
                }
                onClick={() => setFilter(category)}
                aria-pressed={filter === category}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="govindas-gallery-grid">
            {filteredImages.map((image) => (
              <button
                type="button"
                key={`${image.category}-${image.alt}`}
                className="govindas-gallery-item"
                onClick={() => setSelectedImage(image)}
                aria-label={`View larger image: ${image.alt}`}
              >
                <LazyImage
                  src={image.url}
                  alt={image.alt}
                  className="govinda-image"
                />

                <span className="govindas-gallery-zoom" aria-hidden="true">
                  ↗
                </span>

                <span className="govindas-gallery-category">
                  {image.category}
                </span>
              </button>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <p className="govindas-empty-gallery">
              No images available in this category.
            </p>
          )}
        </div>
      </section>

      {/* Contact */}
      <section className="govindas-contact-section" id="govindas-contact">
        <div className="govindas-contact-card">
          <span className="govindas-section-label">
            WE LOOK FORWARD TO WELCOMING YOU
          </span>

          <h2>Plan Your Visit</h2>

          <p>
            For restaurant bookings, celebration enquiries, and further details,
            get in touch with our team.
          </p>

          <div className="govindas-contact-actions">
            <a
              className="govindas-btn govindas-btn-green"
              href={`tel:${phoneNumber}`}
            >
              Call Reception
            </a>

            <a
              className="govindas-btn govindas-btn-whatsapp"
              href={`https://wa.me/${phoneNumber.replace("+", "")}?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Enquire on WhatsApp
            </a>
          </div>

          <a
            className="govindas-email-link"
            href="mailto:govindas@iskconujjain.com"
          >
            govindas@iskconujjain.com
          </a>
        </div>
      </section>

      {/* Image preview */}
      {selectedImage && (
        <div
          className="govindas-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Gallery image preview"
          onClick={() => setSelectedImage(null)}
        >
          <button
            type="button"
            className="govindas-lightbox-close"
            onClick={() => setSelectedImage(null)}
            aria-label="Close image preview"
          >
            ×
          </button>

          <div
            className="govindas-lightbox-content"
            onClick={(event) => event.stopPropagation()}
          >
            <img src={selectedImage.url} alt={selectedImage.alt} />

            <p>{selectedImage.alt}</p>
          </div>
        </div>
      )}
    </main>
  );
};

export default Govindas;
